import fetch from "../utils/fetch";

const ENDPOINT = 'mark_run_as_processed';
export default {
  create(payload) {
    return fetch(ENDPOINT, { method: 'POST', body: JSON.stringify(payload) });
  }
};
